// extracted by mini-css-extract-plugin
var _1 = "Tag-moduleTag__FLr9H";
var _2 = "Tag-moduleclickable__YhO_K";
var _3 = "Tag-moduledisabled__kQkAP";
var _4 = "Tag-moduleerror__eiI6q";
var _5 = "Tag-modulefilled__btcy3";
var _6 = "Tag-moduleheight16__ONj3n";
var _7 = "Tag-moduleheight20__klnuR";
var _8 = "Tag-moduleheight24__Ws_Hj";
var _9 = "Tag-moduleheight28__gfXRt";
var _a = "Tag-moduleheight32__xQKMI";
var _b = "Tag-moduleheight40__JC3Uq";
var _c = "Tag-moduleheight48__ry9Cf";
var _d = "Tag-moduleloading__KJvhH";
var _e = "Tag-modulemetaWrapper__AM_aB";
var _f = "Tag-moduleoutlined__sImtr";
var _10 = "Tag-moduleremoveHovered__a0414";
var _11 = "Tag-moduleskeleton__tvE3y Skeleton-moduleSkeleton__Mlrfv";
export { _1 as "Tag", _2 as "clickable", _3 as "disabled", _4 as "error", _5 as "filled", _6 as "height16", _7 as "height20", _8 as "height24", _9 as "height28", _a as "height32", _b as "height40", _c as "height48", _d as "loading", _e as "metaWrapper", _f as "outlined", _10 as "removeHovered", _11 as "skeleton" }
